import React from 'react';
import { View, TouchableOpacity, Text } from 'react-native';
import { LinearGradient } from "expo-linear-gradient";
import { useNavigation } from '@react-navigation/native';

import styles from './styles';

const Button = ({ route, text, titlePage, props, disabled = false }) => {
    const navigation = useNavigation();
    return (
        <View style={styles.contentBtn}>
            <TouchableOpacity disabled={disabled} onPress={() => navigation.navigate({ name: route, params: { titlePage: titlePage, qtd: props } })}>
                <LinearGradient
                    start={{ x: -1, y: 0 }}
                    end={{ x: 1, y: 0 }}
                    colors={["#16195B", "#1FBFB5"]}
                    style={styles.btn}
                >
                    <Text style={styles.textBtn}>{text}</Text>
                </LinearGradient>
            </TouchableOpacity>
        </View>
    );
}

export default Button;